module.exports = __webpack_public_path__ + "static/media/cennznet.cb6ecb9b.svg";


//////////////////
// WEBPACK FOOTER
// ./src/icons/cennznet.svg
// module id = ./src/icons/cennznet.svg
// module chunks = 0